import { ImResponse, messDoorClient, resolve } from 'services/api';

export function getSensitiveWordList() {
  return resolve(messDoorClient.get<ImResponse<{ word: string[] }>>('/censored/v1/sensitiveWord'));
}

export function removeSensitiveWord(word: string) {
  return messDoorClient.delete('/censored/v1/sensitiveWord', { params: { word } });
}

export function addSensitiveWord(word: string) {
  return messDoorClient.post('/censored/v1/sensitiveWord', { word });
}
